import { Backdrop, CircularProgress } from '@mui/material';

export default function Loading() {
    return (
        <Backdrop sx={{ backgroundColor: '#ffffff' }} open>
            <CircularProgress size="10%" disableShrink />
        </Backdrop>
    );
}
